import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);



if (document.querySelector('.satellit')) {
	let satellit = '.satellit'
	let leaf = '.leaf'
	let leaf = '.leaf'
	let place = '.markierung'
	let links = '.verbindungen'

	// var satellitTl = gsap.timeline()
	var leafTl = gsap.timeline({ repeat: -1, repeatDelay: 2 })


	gsap.to(satellit, {duration: 8, rotation: -30, ease: "none", yoyo: true, repeat:-1,})
	gsap.to(links, {duration: 6, rotation: 30, ease: "none", yoyo: true, repeat:-1, transformOrigin: "bottom right"})
	gsap.to(place, {duration: 1, ease: "none", y: 25, yoyo: true, repeat:-1,})
		
	leafTl
		.to(leaf, {duration: 3, rotation: 10, ease: "back.inOut", yoyo: true, repeat: -1, transformOrigin: "bottom right"})


	let dot = '.signal__punkt'
	let halfCircle1 = '.signal__halbkreis_1'
	let halfCircle2 = '.signal__halbkreis_2'
	let signalTl = gsap.timeline({ repeat: -1, yoyo: true });

	signalTl
			.from(halfCircle1, {duration: .75, opacity: 0,})
			.from(halfCircle2, {duration: .75, opacity: 0, });


	let balken = '.no1__balken'
	let figures = '.no1__figures'
	let numbers = '.no1__numbers'
	var balkenTl = gsap.timeline({ paused: true, });


	balkenTl
		.from(balken, {duration: 1, scaleY: 0, ease: "none", transformOrigin: "bottom", stagger: 0.25})
		.from(numbers, {duration: 1, y: 40, opacity: 0}, "=-.25")
		.from(figures, {duration: 1, opacity: 0}, "=-.5");

	ScrollTrigger.create({
	  trigger: balken
	  onEnter: () => balkenTl.play(),
	  onEnterBack: () => balkenTl.reverse()
	})

}

if (document.querySelector('.joris-svg')) {
	let jorisSvg = '.joris-svg'
	gsap.to(jorisSvg, {duration: 8, y: 50, ease: "none", yoyo: true, repeat:-1,})	
}

if (document.querySelector('.nachfolger__balken--fill')) {
	let nachfolgerBalkenFill = '.nachfolger__balken--fill'
	let balkenAnim = gsap.from(nachfolgerBalkenFill, {duration: 2, scaleX: 0, paused: true})

	ScrollTrigger.create({
	  trigger: nachfolgerBalkenFill
	  onEnter: () => balkenAnim.play(),
	})
}


